<template>
  <div class="t-calendar-header t-calendar_small__header">
    <button class="t-calendar_small__arrow" @click.prevent="PrevMonth()">
      <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.6001 4.00078H12.4001M1.6001 4.00078L5.2001 1.30078M1.6001 4.00078L5.2001 6.70078" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <span>{{ date_active_text }}</span>
    <button class="t-calendar_small__arrow" @click.prevent="NextMonth()">
      <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.3999 4.00078H1.5999M12.3999 4.00078L8.7999 1.30078M12.3999 4.00078L8.7999 6.70078" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        computed: {
            ...mapGetters('calendar', ['date_active_text'])
        },
        methods: {
            ...mapActions('calendar', ['PrevMonth', 'NextMonth'])
        }
    }
</script>



// WEBPACK FOOTER //
// src/vue_components/Calendar_modal/CalendarHeader.vue